import getScenarioStore from '../selectors/getScenarioStore';
import getSegmentSearchBoxText from '../utils/getSegmentSearchBoxText';
import { mutator } from 'satcheljs';
import { setSuggestionSegmentsInternal } from '../actions/internalActions';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';

export default mutator(setSuggestionSegmentsInternal, actionMessage => {
    const store = getScenarioStore(actionMessage.scenarioId);
    const segments: SubstrateSearchSuggestionSegment[] = actionMessage.segments;
    const lastSegment = segments.slice(-1)[0];

    /**
     * If the last segment shouldn't be a pill (i.e. a text segment), then set
     * it as the searchText. All other segments should be added to the store.
     */
    if (lastSegment.Type === 'Person') {
        // Add segments represented as pills to the store.
        for (const segment of segments) {
            store.suggestionSegments.set(segment.DisplayText, segment);
        }
    } else {
        // Add segments represented as pills to the store.
        const pillSegments = segments.slice(0, -1);
        for (const segment of pillSegments) {
            store.suggestionSegments.set(segment.DisplayText, segment);
        }

        // Add last segment to the search box as text.
        store.searchText = getSegmentSearchBoxText(lastSegment);
    }
});
